module.exports = __webpack_public_path__ + "static/media/5.1b557aa7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/5.jpg
// module id = 27
// module chunks = 0